import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo_svg from '../assets/logo_navbar.svg';

const GMB_CID = '17347410219545602477';

export default function Footer() {
  const [ratingData, setRatingData] = useState({
    rating: '0',
    reviewsCount: '0',
  });

  useEffect(() => {
    // 1. Query PlacesService if Google Places SDK is present on window
    if (window.google && window.google.maps && window.google.maps.places) {
      try {
        const dummyDiv = document.createElement('div');
        const service = new window.google.maps.places.PlacesService(dummyDiv);
        service.getDetails(
          {
            placeId: 'ChIJu9sVxjqD1moRrSn_JK9hvvA', // Watt & Wattle Place ID
            fields: ['rating', 'user_ratings_total'],
          },
          (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
              if (place.rating && place.user_ratings_total) {
                setRatingData({
                  rating: Number(place.rating).toFixed(1),
                  reviewsCount: String(place.user_ratings_total),
                });
                return;
              }
            }
          }
        );
      } catch (e) {
        // ignore
      }
    }

    // 2. Read structured data schema metadata tag
    const schemaTag = Array.from(document.querySelectorAll('script[type="application/ld+json"]'))
      .find((tag) => tag.textContent && tag.textContent.includes('AggregateRating'));
    if (schemaTag) {
      try {
        const parsed = JSON.parse(schemaTag.textContent);
        if (parsed.aggregateRating) {
          setRatingData({
            rating: Number(parsed.aggregateRating.ratingValue).toFixed(1),
            reviewsCount: String(parsed.aggregateRating.ratingCount),
          });
        }
      } catch (err) {
        // ignore
      }
    }
  }, []);

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src={logo_svg} alt="Watt & Wattle" />
          </Link>
          <p className="footer-mission">
            Our mission is to bring down the cost of solar by supplying premium-quality components at
            wholesale prices, making clean energy more accessible to households across Melbourne.
          </p>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/p/Watt-and-Wattle-61586713473185/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="footer-social-icon"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.12 8.44 9.88v-6.99H7.9v-2.89h2.54V9.79c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.89h-2.33v6.99C18.34 21.12 22 16.99 22 12z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/wattandwattle/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="footer-social-icon"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-links-col">
          <h4 className="footer-col-title">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/residential-solutions">Residential Solution</Link></li>
            <li><Link to="/commercial-solutions">Commercial Solution</Link></li>
            <li><Link to="/why-us">Why Us</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/sitemap">Sitemap</Link></li>
          </ul>
        </div>

        <div className="footer-contact-col">
          <h4 className="footer-col-title">Contact us</h4>
          <ul className="footer-contact-list">
            <li>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="white" />
              </svg>
              <a href="tel:0414339191">0414 339 191</a>
            </li>
            <li>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="white" />
              </svg>
              <a href="mailto:sales@wattandwattle.com.au">sales@wattandwattle.com.au</a>
            </li>
            <li>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="white" />
              </svg>
              <span>1 Wayne Court, Dandenong, VIC, 3175</span>
            </li>
          </ul>

          <a
            href={`https://maps.app.goo.gl/ReorFrDEmYzov9WU8`}
            target="_blank"
            rel="noopener noreferrer"
            className="google-review-badge"
          >
            <div className="google-badge-left">
              <svg width="28" height="28" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
              </svg>
            </div>
            <div className="google-badge-right">
              <div className="google-badge-rating-row">
                <span className="google-badge-rating">{ratingData.rating}</span>
                <div className="google-badge-stars">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#FF8A00">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                  ))}
                </div>
              </div>
              <span className="google-badge-reviews-count">{ratingData.reviewsCount} REVIEWS</span>
            </div>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Copyright © {new Date().getFullYear()} Watt &amp; Wattle. All Rights Reserved. | ABN: 65 688 155 473 | <Link to="/sitemap" className="footer-sitemap-link">Sitemap</Link>
        </p>
      </div>
    </footer>
  );
}
